export const placementCVList = [
  {
    category: "core",
    company: "ARUP",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Swaminathan_Velraj__cv_2026.png",
    createdAt: "2026-08-31T13:14:29.905Z",
    dept: "AR",
    id: 344,
    name_: "Swaminathan Velraj ",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Swaminathan_Velraj__cv_2026_thumb.png",
    title: "ARUP | AR",
  },
  {
    category: "product",
    company: "Swiggy Instamart",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Shuchika_R_Mallal_cv_2026.png",
    createdAt: "2026-08-31T13:11:58.065Z",
    dept: "AG",
    id: 343,
    name_: "Shuchika R Mallal",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Shuchika_R_Mallal_cv_2026_thumb.png",
    title: "Swiggy Instamart | AG",
  },
  {
    category: "core",
    company: "Bajaj Auto",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Saptarshi_Pramanik_cv_2026.png",
    createdAt: "2026-08-31T13:10:07.174Z",
    dept: "IP",
    id: 342,
    name_: "Saptarshi Pramanik",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Saptarshi_Pramanik_cv_2026_thumb.png",
    title: "Bajaj Auto | IP",
  },
  {
    category: "data",
    company: "Commonwealth Bank of Australia",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Vishnu_Vardhan_Kolathuru_cv_2026.png",
    createdAt: "2026-08-31T12:40:43.902Z",
    dept: "CE",
    id: 341,
    name_: "Vishnu Vardhan Kolathuru",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Vishnu_Vardhan_Kolathuru_cv_2026_thumb.png",
    title: "Commonwealth Bank of Australia | CE",
  },
  {
    category: "core",
    company: "Larsen & Toubro",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Ramavarapu_Dhanush_cv_2026.png",
    createdAt: "2026-08-31T12:39:36.745Z",
    dept: "CE",
    id: 340,
    name_: "Ramavarapu Dhanush",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Ramavarapu_Dhanush_cv_2026_thumb.png",
    title: "Larsen & Toubro | CE",
  },
  {
    category: "core",
    company: "Bajaj Auto Ltd",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Rakshit_Raj_cv_2026.png",
    createdAt: "2026-08-31T12:37:51.635Z",
    dept: "ME",
    id: 339,
    name_: "Rakshit Raj",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Rakshit_Raj_cv_2026_thumb.png",
    title: "Bajaj Auto Ltd | ME",
  },
  {
    category: "core",
    company: "Larsen & Toubro",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Sumedh_Dongrajkar_cv_2026.png",
    createdAt: "2026-08-31T12:36:04.454Z",
    dept: "CE",
    id: 338,
    name_: "Sumedh Dongrajkar",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Sumedh_Dongrajkar_cv_2026_thumb.png",
    title: "Larsen & Toubro | CE",
  },
  {
    category: "data",
    company: "Fedex",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Tushar_Kumar_cv_2026.png",
    createdAt: "2026-08-31T12:35:01.071Z",
    dept: "CH",
    id: 337,
    name_: "Tushar Kumar",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Tushar_Kumar_cv_2026_thumb.png",
    title: "Fedex | CH",
  },
  {
    category: "software",
    company: "ESDS Software Solutions",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Shivani_Kesharwani_cv_2026.png",
    createdAt: "2026-08-31T12:34:10.191Z",
    dept: "IM",
    id: 336,
    name_: "Shivani Kesharwani",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Shivani_Kesharwani_cv_2026_thumb.png",
    title: "ESDS Software Solutions | IM",
  },
  {
    category: "core",
    company: "Qualcomm",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Venkatesh_B_cv_2026.png",
    createdAt: "2026-08-31T12:32:57.432Z",
    dept: "EC",
    id: 335,
    name_: "Venkatesh B",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Venkatesh_B_cv_2026_thumb.png",
    title: "Qualcomm | EC",
  },
  {
    category: "core",
    company: "ExxonMobil",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Musunuri_Anjani_cv_2026.png",
    createdAt: "2026-08-31T12:29:24.605Z",
    dept: "CE",
    id: 334,
    name_: "Musunuri Anjani",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Musunuri_Anjani_cv_2026_thumb.png",
    title: "ExxonMobil | CE",
  },
  {
    category: "data",
    company: "JPMorgan Chase and Co.",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Vedant_Katole_cv_2026.png",
    createdAt: "2026-08-31T12:26:44.174Z",
    dept: "EC",
    id: 333,
    name_: "Vedant Katole",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Vedant_Katole_cv_2026_thumb.png",
    title: "JPMorgan Chase and Co. | EC",
  },
  {
    category: "data",
    company: "Accenture",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Smrutiranjan_Dalai_cv_2026.png",
    createdAt: "2026-08-31T12:26:04.453Z",
    dept: "CS",
    id: 332,
    name_: "Smrutiranjan Dalai",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Smrutiranjan_Dalai_cv_2026_thumb.png",
    title: "Accenture | CS",
  },
  {
    category: "software",
    company: "Standard Chartered",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Vishal_Kochar_cv_2026.png",
    createdAt: "2026-08-31T12:24:59.480Z",
    dept: "AE",
    id: 331,
    name_: "Vishal Kochar",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Vishal_Kochar_cv_2026_thumb.png",
    title: "Standard Chartered | AE",
  },
  {
    category: "software",
    company: "Mastercard",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Darapu_Adhithya_Shiva_Kumar_Reddy__cv_2026.png",
    createdAt: "2026-08-31T12:24:48.812Z",
    dept: "CS",
    id: 330,
    name_: "Darapu Adhithya Shiva Kumar Reddy ",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Darapu_Adhithya_Shiva_Kumar_Reddy__cv_2026_thumb.png",
    title: "Mastercard | CS",
  },
  {
    category: "software",
    company: "NatWest Group",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Shashvat_Patel_cv_2026.png",
    createdAt: "2026-08-31T12:23:23.718Z",
    dept: "AG",
    id: 329,
    name_: "Shashvat Patel",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Shashvat_Patel_cv_2026_thumb.png",
    title: "NatWest Group | AG",
  },
  {
    category: "finance",
    company: "CITI BANK",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Vivek_Thakur_cv_2026.png",
    createdAt: "2026-08-31T12:23:07.100Z",
    dept: "HS",
    id: 328,
    name_: "Vivek Thakur",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Vivek_Thakur_cv_2026_thumb.png",
    title: "CITI BANK | HS",
  },
  {
    category: "core",
    company: "Slnko Energy Pvt.Ltd",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/A_Vamsi_Krishna_cv_2026.png",
    createdAt: "2026-08-31T12:21:40.001Z",
    dept: "EE",
    id: 327,
    name_: "A Vamsi Krishna",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/A_Vamsi_Krishna_cv_2026_thumb.png",
    title: "Slnko Energy Pvt.Ltd | EE",
  },
  {
    category: "data",
    company: "American Express",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Semanti_Ghosh_cv_2026.png",
    createdAt: "2026-08-31T12:21:31.026Z",
    dept: "IM",
    id: 326,
    name_: "Semanti Ghosh",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Semanti_Ghosh_cv_2026_thumb.png",
    title: "American Express | IM",
  },
  {
    category: "software",
    company: "Amazon",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Vedic_Dutta_cv_2026.png",
    createdAt: "2026-08-31T12:20:03.591Z",
    dept: "CH",
    id: 325,
    name_: "Vedic Dutta",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Vedic_Dutta_cv_2026_thumb.png",
    title: "Amazon | CH",
  },
  {
    category: "software",
    company: "Razorpay",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Harshit_Pathak_cv_2026.png",
    createdAt: "2026-08-31T12:19:51.620Z",
    dept: "IE",
    id: 324,
    name_: "Harshit Pathak",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Harshit_Pathak_cv_2026_thumb.png",
    title: "Razorpay | IE",
  },
  {
    category: "data",
    company: "SLB",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Sayan_Ghosh_cv_2026.png",
    createdAt: "2026-08-31T12:18:54.812Z",
    dept: "CH",
    id: 323,
    name_: "Sayan Ghosh",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Sayan_Ghosh_cv_2026_thumb.png",
    title: "SLB | CH",
  },
  {
    category: "core",
    company: "NVIDIA",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Dillip_Dibyajyoti_Dash_cv_2026.png",
    createdAt: "2026-08-31T12:17:44.949Z",
    dept: "EC",
    id: 322,
    name_: "Dillip Dibyajyoti Dash",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Dillip_Dibyajyoti_Dash_cv_2026_thumb.png",
    title: "NVIDIA | EC",
  },
  {
    category: "data",
    company: "Sigmoid",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Soham_Mandal_cv_2026.png",
    createdAt: "2026-08-31T12:16:11.601Z",
    dept: "EE",
    id: 321,
    name_: "Soham Mandal",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Soham_Mandal_cv_2026_thumb.png",
    title: "Sigmoid | EE",
  },
  {
    category: "core",
    company: "SLnko Energy Pvt Ltd ",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Anand_Kumar__cv_2026.png",
    createdAt: "2026-08-31T12:14:09.800Z",
    dept: "CE",
    id: 320,
    name_: "Anand Kumar ",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Anand_Kumar__cv_2026_thumb.png",
    title: "SLnko Energy Pvt Ltd | CE",
  },
  {
    category: "data",
    company: "ICICI BANK",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Tiyas_Roy_Choudhury_cv_2026.png",
    createdAt: "2026-08-31T12:12:05.751Z",
    dept: "CE",
    id: 319,
    name_: "Tiyas Roy Choudhury",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Tiyas_Roy_Choudhury_cv_2026_thumb.png",
    title: "ICICI BANK | CE",
  },
  {
    category: "core",
    company: "GE Aerospace",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Seshu_Sai_Kumar_M_cv_2026.png",
    createdAt: "2026-08-31T12:07:34.049Z",
    dept: "AE",
    id: 318,
    name_: "Seshu Sai Kumar M",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Seshu_Sai_Kumar_M_cv_2026_thumb.png",
    title: "GE Aerospace | AE",
  },
  {
    category: "software",
    company: "Amazon",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Aditya_Singh_Sisodia_cv_2026.png",
    createdAt: "2026-08-31T11:54:32.165Z",
    dept: "MI",
    id: 317,
    name_: "Aditya Singh Sisodia",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Aditya_Singh_Sisodia_cv_2026_thumb.png",
    title: "Amazon | MI",
  },
  {
    category: "core",
    company: "NVIDIA",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Pradyumn_Mahajan_cv_2026.png",
    createdAt: "2026-08-31T11:52:45.653Z",
    dept: "AE",
    id: 316,
    name_: "Pradyumn Mahajan",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Pradyumn_Mahajan_cv_2026_thumb.png",
    title: "NVIDIA | AE",
  },
  {
    category: "finance",
    company: "CITI Bank",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Siddharth_Pandey_cv_2026.png",
    createdAt: "2026-08-31T11:51:20.073Z",
    dept: "HS",
    id: 315,
    name_: "Siddharth Pandey",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Siddharth_Pandey_cv_2026_thumb.png",
    title: "CITI Bank | HS",
  },
  {
    category: "consultancy",
    company: "HPE",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Soubhik_Shit_cv_2026.png",
    createdAt: "2026-08-31T11:41:10.723Z",
    dept: "MF",
    id: 314,
    name_: "Soubhik Shit",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Soubhik_Shit_cv_2026_thumb.png",
    title: "HPE | MF",
  },
  {
    category: "software",
    company: "Navi Technologies",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Cheekoti_Likhitha_cv_2026.png",
    createdAt: "2026-08-31T11:28:14.281Z",
    dept: "PH",
    id: 313,
    name_: "Cheekoti Likhitha",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Cheekoti_Likhitha_cv_2026_thumb.png",
    title: "Navi Technologies | PH",
  },
  {
    category: "data",
    company: "EY GDS",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Vivek_Sharma_cv_2026.png",
    createdAt: "2026-08-31T11:26:40.613Z",
    dept: "BT",
    id: 291,
    name_: "Vivek Sharma",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Vivek_Sharma_cv_2026_thumb.png",
    title: "EY GDS | BT",
  },
  {
    category: "software",
    company: "Sai Group",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Vivekanand_cv_2026.png",
    createdAt: "2026-08-31T11:20:26.709Z",
    dept: "CS",
    id: 312,
    name_: "Vivekanand",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Vivekanand_cv_2026_thumb.png",
    title: "Sai Group | CS",
  },
  {
    category: "software",
    company: "Bank of America",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Snigdha_Biswas_cv_2026.png",
    createdAt: "2026-08-31T11:17:50.944Z",
    dept: "CS",
    id: 311,
    name_: "Snigdha Biswas",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Snigdha_Biswas_cv_2026_thumb.png",
    title: "Bank of America | CS",
  },
  {
    category: "software",
    company: "Ebay",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Marudhara_Mridula_cv_2026.png",
    createdAt: "2026-08-31T11:12:01.806Z",
    dept: "CE",
    id: 310,
    name_: "Marudhara Mridula",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Marudhara_Mridula_cv_2026_thumb.png",
    title: "Ebay | CE",
  },
  {
    category: "product",
    company: "Flipkart",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Siddharth_Asthana_cv_2026.png",
    createdAt: "2026-08-31T11:08:19.324Z",
    dept: "MI",
    id: 309,
    name_: "Siddharth Asthana",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Siddharth_Asthana_cv_2026_thumb.png",
    title: "Flipkart | MI",
  },
  {
    category: "data",
    company: "EY GDS",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Vishal_Kumar_Lal_cv_2026.png",
    createdAt: "2026-08-31T11:04:02.041Z",
    dept: "BT",
    id: 308,
    name_: "Vishal Kumar Lal",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Vishal_Kumar_Lal_cv_2026_thumb.png",
    title: "EY GDS | BT",
  },
  {
    category: "software",
    company: "Inspira Enterprise",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Satyam_Raj_cv_2026.png",
    createdAt: "2026-08-31T11:01:59.072Z",
    dept: "MT",
    id: 307,
    name_: "Satyam Raj",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Satyam_Raj_cv_2026_thumb.png",
    title: "Inspira Enterprise | MT",
  },
  {
    category: "data",
    company: "ESDS Software solutions Limited",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Abhinav_Kumar_cv_2026.png",
    createdAt: "2026-08-31T10:59:22.887Z",
    dept: "AE",
    id: 306,
    name_: "Abhinav Kumar",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Abhinav_Kumar_cv_2026_thumb.png",
    title: "ESDS Software solutions Limited | AE",
  },
  {
    category: "software",
    company: "Nasiko",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Alok_Kumar_cv_2026.png",
    createdAt: "2026-08-31T10:56:08.528Z",
    dept: "CE",
    id: 305,
    name_: "Alok Kumar",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Alok_Kumar_cv_2026_thumb.png",
    title: "Nasiko | CE",
  },
  {
    category: "core",
    company: "Larsen & Toubro",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Vikram_Singh_Meena_cv_2026.png",
    createdAt: "2026-08-31T10:53:33.303Z",
    dept: "CE",
    id: 304,
    name_: "Vikram Singh Meena",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Vikram_Singh_Meena_cv_2026_thumb.png",
    title: "Larsen & Toubro | CE",
  },
  {
    category: "consultancy",
    company: "Eternal Limited",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Aishwarya_Maan_Srivastava_cv_2026.png",
    createdAt: "2026-08-31T10:48:32.139Z",
    dept: "HS",
    id: 303,
    name_: "Aishwarya Maan Srivastava",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Aishwarya_Maan_Srivastava_cv_2026_thumb.png",
    title: "Eternal Limited | HS",
  },
  {
    category: "software",
    company: "Capital One",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Jatin_Toshniwal_cv_2026.png",
    createdAt: "2026-08-31T10:46:03.424Z",
    dept: "HS",
    id: 302,
    name_: "Jatin Toshniwal",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Jatin_Toshniwal_cv_2026_thumb.png",
    title: "Capital One | HS",
  },
  {
    category: "software",
    company: "Nasiko",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Satya_Yalla_cv_2026.png",
    createdAt: "2026-08-31T10:40:36.185Z",
    dept: "EC",
    id: 301,
    name_: "Satya Yalla",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Satya_Yalla_cv_2026_thumb.png",
    title: "Nasiko | EC",
  },
  {
    category: "software",
    company: "Nexusone",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Raghav_Agarwal_cv_2026.png",
    createdAt: "2026-08-31T10:37:25.365Z",
    dept: "BT",
    id: 300,
    name_: "Raghav Agarwal",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Raghav_Agarwal_cv_2026_thumb.png",
    title: "Nexusone | BT",
  },
  {
    category: "data",
    company: "EXL",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Mahesh_Yadav_cv_2026.png",
    createdAt: "2026-08-29T17:12:46.274Z",
    dept: "EE",
    id: 299,
    name_: "Mahesh Yadav",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Mahesh_Yadav_cv_2026_thumb.png",
    title: "EXL | EE",
  },
  {
    category: "core",
    company: "Bajaj Auto Technology Limited",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Sukalpita_Das_cv_2026.png",
    createdAt: "2026-08-29T17:10:54.533Z",
    dept: "EE",
    id: 298,
    name_: "Sukalpita Das",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Sukalpita_Das_cv_2026_thumb.png",
    title: "Bajaj Auto Technology Limited | EE",
  },
  {
    category: "data",
    company: "American Express",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Krishnendu_Nayek_cv_2026.png",
    createdAt: "2026-08-29T17:08:20.279Z",
    dept: "EE",
    id: 297,
    name_: "Krishnendu Nayek",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Krishnendu_Nayek_cv_2026_thumb.png",
    title: "American Express | EE",
  },
  {
    category: "software",
    company: "HCL Tech",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Akshat_Thapa_cv_2026.png",
    createdAt: "2026-08-29T17:05:42.887Z",
    dept: "MM",
    id: 296,
    name_: "Akshat Thapa",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Akshat_Thapa_cv_2026_thumb.png",
    title: "HCL Tech | MM",
  },
  {
    category: "software",
    company: "Amazon",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Himanshu_Likhar_cv_2026.png",
    createdAt: "2026-08-29T17:04:43.728Z",
    dept: "CS",
    id: 295,
    name_: "Himanshu Likhar",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Himanshu_Likhar_cv_2026_thumb.png",
    title: "Amazon | CS",
  },
  {
    category: "data",
    company: "Ebay",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Mrinmoy_Dey_cv_2026.png",
    createdAt: "2026-08-29T17:03:33.304Z",
    dept: "MI",
    id: 294,
    name_: "Mrinmoy Dey",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Mrinmoy_Dey_cv_2026_thumb.png",
    title: "Ebay | MI",
  },
  {
    category: "data",
    company: "Straive",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Ishan_Kanodia_cv_2026.png",
    createdAt: "2026-08-29T17:03:26.766Z",
    dept: "AE",
    id: 293,
    name_: "Ishan Kanodia",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Ishan_Kanodia_cv_2026_thumb.png",
    title: "Straive | AE",
  },
  {
    category: "software",
    company: "Microsoft",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Anand_Malav_Rameshchandra_cv_2026.png",
    createdAt: "2026-08-29T17:01:24.815Z",
    dept: "CS",
    id: 292,
    name_: "Anand Malav Rameshchandra",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Anand_Malav_Rameshchandra_cv_2026_thumb.png",
    title: "Microsoft | CS",
  },
  {
    category: "consultancy",
    company: "PwC",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Vaibhav_Jha_cv_2026.png",
    createdAt: "2026-08-29T17:00:42.850Z",
    dept: "MI",
    id: 218,
    name_: "Vaibhav Jha",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Vaibhav_Jha_cv_2026_thumb.png",
    title: "PwC | MI",
  },
  {
    category: "data",
    company: "ICICI Bank",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Shalin_Chakraborty_cv_2026.png",
    createdAt: "2026-08-29T16:57:14.429Z",
    dept: "CE",
    id: 217,
    name_: "Shalin Chakraborty",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Shalin_Chakraborty_cv_2026_thumb.png",
    title: "ICICI BANK | CE",
  },
  {
    category: "data",
    company: "American Express",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Priyanshu_Singh_cv_2026.png",
    createdAt: "2026-08-29T16:43:35.696Z",
    dept: "ME",
    id: 216,
    name_: "Priyanshu Singh",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Priyanshu_Singh_cv_2026_thumb.png",
    title: "American Express | ME",
  },
  {
    category: "core",
    company: "ITC",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Dhruv_Jain_cv_2026.png",
    createdAt: "2026-08-29T16:42:28.763Z",
    dept: "CH",
    id: 215,
    name_: "Dhruv Jain",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Dhruv_Jain_cv_2026_thumb.png",
    title: "ITC | CH",
  },
  {
    category: "software",
    company: "Microsoft",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Dadi_Sasank_Kumar_cv_2026.png",
    createdAt: "2026-08-29T16:40:37.191Z",
    dept: "CS",
    id: 214,
    name_: "Dadi Sasank Kumar",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Dadi_Sasank_Kumar_cv_2026_thumb.png",
    title: "Microsoft | CS",
  },
  {
    category: "software",
    company: "Eternal",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Sachin_cv_2026.png",
    createdAt: "2026-08-29T16:39:33.532Z",
    dept: "CH",
    id: 213,
    name_: "Sachin",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Sachin_cv_2026_thumb.png",
    title: "Eternal | CH",
  },
  {
    category: "core",
    company: "Rekise Marine",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Shreyansh_Kansal_cv_2026.png",
    createdAt: "2026-08-29T16:38:19.951Z",
    dept: "IE",
    id: 212,
    name_: "Shreyansh Kansal",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Shreyansh_Kansal_cv_2026_thumb.png",
    title: "Rekise Marine | IE",
  },
  {
    category: "software",
    company: "Apple",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Gunda_Charu_Vikram_Subhash_cv_2026.png",
    createdAt: "2026-08-29T16:36:59.636Z",
    dept: "CS",
    id: 211,
    name_: "Gunda Charu Vikram Subhash",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Gunda_Charu_Vikram_Subhash_cv_2026_thumb.png",
    title: "Apple | CS",
  },
  {
    category: "software",
    company: "Aakash Educational Services Limited",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Jatin_Gupta_cv_2026.png",
    createdAt: "2026-08-29T16:35:36.431Z",
    dept: "IM",
    id: 210,
    name_: "Jatin Gupta",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Jatin_Gupta_cv_2026_thumb.png",
    title: "Aakash Educational Services Limited | IM",
  },
  {
    category: "product",
    company: "Innovaccer",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/G.V.K._Sai_Sarath_cv_2025.png",
    createdAt: "2025-08-31T17:20:55.399Z",
    dept: "MF",
    id: 209,
    name_: "G.V.K. Sai Sarath",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/G.V.K._Sai_Sarath_cv_2025.png",
    title: "Innovaccer | MF",
  },
  {
    category: "finance",
    company: "ICICI Bank",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Rohit_Rajendra_Gaikwad_cv_2025.png",
    createdAt: "2025-08-31T17:07:28.183Z",
    dept: "MT",
    id: 208,
    name_: "Rohit Rajendra Gaikwad",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Rohit_Rajendra_Gaikwad_cv_2025.png",
    title: "ICICI Bank | MT",
  },
  {
    category: "software",
    company: "Siemens EDA",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Akshay_B_Raj_cv_2025.png",
    createdAt: "2025-08-31T17:04:09.221Z",
    dept: "EC",
    id: 207,
    name_: "Akshay B Raj",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Akshay_B_Raj_cv_2025.png",
    title: "Siemens EDA | EC",
  },
  {
    category: "core",
    company: "Quant Solar Pvt. Ltd.",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Devkishan_Khatri_cv_2025.png",
    createdAt: "2025-08-31T17:01:21.232Z",
    dept: "NA",
    id: 206,
    name_: "Devkishan Khatri",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Devkishan_Khatri_cv_2025.png",
    title: "Quant Solar Pvt. Ltd. | NA",
  },
  {
    category: "data",
    company: "Accenture",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Akriti_Sakshi_cv_2025.png",
    createdAt: "2025-08-31T16:58:25.573Z",
    dept: "IM",
    id: 205,
    name_: "Akriti Sakshi",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Akriti_Sakshi_cv_2025.png",
    title: "Accenture | IM",
  },
  {
    category: "core",
    company: "Samsung R&D",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Khole_Rohan_Rajendra_cv_2025.png",
    createdAt: "2025-08-31T16:52:48.584Z",
    dept: "CS",
    id: 204,
    name_: "Khole Rohan Rajendra",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Khole_Rohan_Rajendra_cv_2025.png",
    title: "Samsung R&D | CS",
  },
  {
    category: "software",
    company: "Ultimate Kronos Group",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Ritik_Kumar_cv_2025.png",
    createdAt: "2025-08-31T16:45:04.074Z",
    dept: "MA",
    id: 203,
    name_: "Ritik Kumar",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Ritik_Kumar_cv_2025.png",
    title: "Ultimate Kronos Group | MA",
  },
  {
    category: "software",
    company: "PhonePe",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Kunal_Verma_cv_2025.png",
    createdAt: "2025-08-31T16:42:42.704Z",
    dept: "CH",
    id: 202,
    name_: "Kunal Verma",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Kunal_Verma_cv_2025.png",
    title: "PhonePe | CH",
  },
  {
    category: "software",
    company: "SLB Tech",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Sayan_Tapadar_cv_2025.png",
    createdAt: "2025-08-31T16:40:37.246Z",
    dept: "EE",
    id: 201,
    name_: "Sayan Tapadar",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Sayan_Tapadar_cv_2025.png",
    title: "SLB Tech | EE",
  },
  {
    category: "data",
    company: "Husk Power Systems",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Debangshu_Bose_cv_2025.png",
    createdAt: "2025-08-31T16:30:13.524Z",
    dept: "CL",
    id: 200,
    name_: "Debangshu Bose",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Debangshu_Bose_cv_2025.png",
    title: "Husk Power Systems | CL",
  },
  {
    category: "software",
    company: "Addverb Technologies",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Lakshya_Bamne_cv_2025.png",
    createdAt: "2025-08-31T16:24:39.881Z",
    dept: "MA",
    id: 199,
    name_: "Lakshya Bamne",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Lakshya_Bamne_cv_2025.png",
    title: "Addverb Technologies | MA",
  },
  {
    category: "core",
    company: "Qualcomm",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Prakhar_Mishra_cv_2025.png",
    createdAt: "2025-08-31T16:18:54.015Z",
    dept: "EC",
    id: 198,
    name_: "Prakhar Mishra",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Prakhar_Mishra_cv_2025.png",
    title: "Qualcomm | EC",
  },
  {
    category: "data",
    company: "Turing",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Vishwas_Jajpura_cv_2025.png",
    createdAt: "2025-08-31T16:14:48.399Z",
    dept: "AE",
    id: 197,
    name_: "Vishwas Jajpura",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Vishwas_Jajpura_cv_2025.png",
    title: "Turing | AE",
  },
  {
    category: "core",
    company: "Qualcomm",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Debanu_Das_cv_2025.png",
    createdAt: "2025-08-31T15:18:16.648Z",
    dept: "EC",
    id: 196,
    name_: "Debanu Das",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Debanu_Das_cv_2025.png",
    title: "Qualcomm | EC",
  },
  {
    category: "software",
    company: "MasterCard",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Harsh_Wasnik_cv_2025.png",
    createdAt: "2025-08-31T11:13:13.606Z",
    dept: "MA",
    id: 195,
    name_: "Harsh Wasnik",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Harsh_Wasnik_cv_2025.png",
    title: "MasterCard | MA",
  },
  {
    category: "software",
    company: "Samsara",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Sreekar_Basa_cv_2025.png",
    createdAt: "2025-08-31T11:08:58.605Z",
    dept: "EE",
    id: 194,
    name_: "Sreekar Basa",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Sreekar_Basa_cv_2025.png",
    title: "Samsara | EE",
  },
  {
    category: "software",
    company: "Cars24",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Jai_Mrothiya_cv_2025.png",
    createdAt: "2025-08-31T11:07:15.286Z",
    dept: "MF",
    id: 193,
    name_: "Jai Mrothiya",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Jai_Mrothiya_cv_2025.png",
    title: "Cars24 | MF",
  },
  {
    category: "data",
    company: "Axtria Ingenious Insights",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Yash_Raj_cv_2025.png",
    createdAt: "2025-08-31T11:05:59.507Z",
    dept: "MI",
    id: 192,
    name_: "Yash Raj",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Yash_Raj_cv_2025.png",
    title: "Axtria Ingenious Insights | IM",
  },
  {
    category: "quant",
    company: "Junomoneta Finsol Pvt. Ltd.",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Ankit_Das_cv_2025.png",
    createdAt: "2025-08-31T11:02:26.407Z",
    dept: "MT",
    id: 191,
    name_: "Ankit Das",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Ankit_Das_cv_2025.png",
    title: "Junomoneta Finsol Pvt. Ltd. | MT",
  },
  {
    category: "software",
    company: "Squarepoint Capital",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Krish_Agarwal_cv_2025.png",
    createdAt: "2025-08-31T11:01:23.785Z",
    dept: "MA",
    id: 190,
    name_: "Krish Agarwal",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Krish_Agarwal_cv_2025.png",
    title: "Squarepoint Capital | MA",
  },
  {
    category: "software",
    company: "Capillary Technologies",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Kajol_Sahu_cv_2025.png",
    createdAt: "2025-08-31T10:59:07.716Z",
    dept: "CY",
    id: 189,
    name_: "Kajol Sahu",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Kajol_Sahu_cv_2025.png",
    title: "Capillary Technologies | CY",
  },
  {
    category: "product",
    company: "BlueStone",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Biswa_Ranjan_Barik_cv_2025.png",
    createdAt: "2025-08-31T10:56:48.918Z",
    dept: "IM",
    id: 188,
    name_: "Biswa Ranjan Barik",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Biswa_Ranjan_Barik_cv_2025.png",
    title: "BlueStone | IM",
  },
  {
    category: "finance",
    company: "Meesho",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Pravalika_Das_cv_2025.png",
    createdAt: "2025-08-31T10:53:51.713Z",
    dept: "CH",
    id: 186,
    name_: "Pravalika Das",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Pravalika_Das_cv_2025.png",
    title: "Meesho | CH",
  },
  {
    category: "core",
    company: "CBS",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Puneet_Kalra_cv_2025.png",
    createdAt: "2025-08-31T10:53:19.141Z",
    dept: "MF",
    id: 185,
    name_: "Puneet Kalra",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Puneet_Kalra_cv_2025.png",
    title: "CBS | MF",
  },
  {
    category: "data",
    company: "Axxela",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Devraj_Das_Adhikary_cv_2025.png",
    createdAt: "2025-08-31T10:52:30.813Z",
    dept: "NA",
    id: 184,
    name_: "Devraj Das Adhikary",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Devraj_Das_Adhikary_cv_2025.png",
    title: "Axxela | NA",
  },
  {
    category: "core",
    company: "SEDEMAC",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Asish_Pani_cv_2025.png",
    createdAt: "2025-08-31T10:51:04.757Z",
    dept: "ME",
    id: 183,
    name_: "Asish Pani",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Asish_Pani_cv_2025.png",
    title: "SEDEMAC | ME",
  },
  {
    category: "software",
    company: "Databricks",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Mayukha_Marla_cv_2025.png",
    createdAt: "2025-08-31T10:50:57.188Z",
    dept: "CS",
    id: 182,
    name_: "Mayukha Marla",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Mayukha_Marla_cv_2025.png",
    title: "Databricks | CS",
  },
  {
    category: "software",
    company: "Pace Stock Broking ",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Arup_Baral_cv_2025.png",
    createdAt: "2025-08-31T10:50:06.490Z",
    dept: "MA",
    id: 181,
    name_: "Arup Baral",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Arup_Baral_cv_2025.png",
    title: "Pace Stock Broking  | MA",
  },
  {
    category: "data",
    company: "Axis Bank",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Johaan_George_cv_2025.png",
    createdAt: "2025-08-31T10:48:54.720Z",
    dept: "NA",
    id: 180,
    name_: "Johaan George",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Johaan_George_cv_2025.png",
    title: "Axis Bank | NA",
  },
  {
    category: "software",
    company: "TruckX",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Harsh_Khasbage_cv_2025.png",
    createdAt: "2025-08-31T10:48:53.588Z",
    dept: "CS",
    id: 179,
    name_: "Harsh Khasbage",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Harsh_Khasbage_cv_2025.png",
    title: "TruckX | CS",
  },
  {
    category: "software",
    company: "Ultimate Kronos Group",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Dibyansh_Sekhar_Das_cv_2025.png",
    createdAt: "2025-08-31T10:48:29.060Z",
    dept: "EE",
    id: 178,
    name_: "Dibyansh Sekhar Das",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Dibyansh_Sekhar_Das_cv_2025.png",
    title: "Ultimate Kronos Group | EE",
  },
  {
    category: "data",
    company: "American Express",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Roshni_Biswas_cv_2025.png",
    createdAt: "2025-08-31T10:47:44.044Z",
    dept: "AE",
    id: 177,
    name_: "Roshni Biswas",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Roshni_Biswas_cv_2025.png",
    title: "American Express | AE",
  },
  {
    category: "core",
    company: "Qualcomm",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Sankalp_N_Bharadwaj_cv_2025.png",
    createdAt: "2025-08-31T10:47:39.631Z",
    dept: "EC",
    id: 176,
    name_: "Sankalp N Bharadwaj",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Sankalp_N_Bharadwaj_cv_2025.png",
    title: "Qualcomm | EC",
  },
  {
    category: "software",
    company: "InMobi",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Jogu_Bhanu_Teja_cv_2025.png",
    createdAt: "2025-08-31T10:46:14.242Z",
    dept: "AE",
    id: 175,
    name_: "Jogu Bhanu Teja",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Jogu_Bhanu_Teja_cv_2025.png",
    title: "InMobi | AE",
  },
  {
    category: "data",
    company: "IDFC First Bank",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Sayali_Gaikwad_cv_2025.png",
    createdAt: "2025-08-31T10:46:07.300Z",
    dept: "NA",
    id: 174,
    name_: "Sayali Gaikwad",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Sayali_Gaikwad_cv_2025.png",
    title: "IDFC First Bank | NA",
  },
  {
    category: "software",
    company: "Bank of America",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Kshitij_Banerjee_cv_2025.png",
    createdAt: "2025-08-31T10:45:24.364Z",
    dept: "EE",
    id: 173,
    name_: "Kshitij Banerjee",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Kshitij_Banerjee_cv_2025.png",
    title: "Bank of America | EE",
  },
  {
    category: "data",
    company: "Virtusa",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Arpit_Dubey_cv_2025.png",
    createdAt: "2025-08-31T10:42:46.510Z",
    dept: "MA",
    id: 172,
    name_: "Arpit Dubey",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Arpit_Dubey_cv_2025.png",
    title: "Virtusa | MA",
  },
  {
    category: "data",
    company: "American Express",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Suraj_Gupta_cv_2025.png",
    createdAt: "2025-08-31T10:40:13.282Z",
    dept: "HS",
    id: 171,
    name_: "Suraj Gupta",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Suraj_Gupta_cv_2025.png",
    title: "American Express | HS",
  },
  {
    category: "data",
    company: "Accordion ",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Mayuresh_Lohani_cv_2025.png",
    createdAt: "2025-08-31T10:39:28.532Z",
    dept: "MT",
    id: 170,
    name_: "Mayuresh Lohani",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Mayuresh_Lohani_cv_2025.png",
    title: "Accordion | MT",
  },
  {
    category: "core",
    company: "IBM",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Kankana_Chandra_cv_2025.png",
    createdAt: "2025-08-31T10:38:27.320Z",
    dept: "EC",
    id: 169,
    name_: "Kankana Chandra",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Kankana_Chandra_cv_2025.png",
    title: "IBM | EC",
  },
  {
    category: "product",
    company: "Switch Mobility",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Sadiq_Saleem__cv_2025.png",
    createdAt: "2025-08-31T10:38:11.726Z",
    dept: "AT",
    id: 168,
    name_: "Sadiq Saleem ",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Sadiq_Saleem__cv_2025.png",
    title: "Switch Mobility | AT",
  },
  {
    category: "software",
    company: "Microsoft",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Kshitij_Das_cv_2025.png",
    createdAt: "2025-08-31T10:36:44.084Z",
    dept: "CS",
    id: 167,
    name_: "Kshitij Das",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Kshitij_Das_cv_2025.png",
    title: "Microsoft | CS",
  },
  {
    category: "core",
    company: "Linde",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Niranjan_K_Sabu_cv_2025.png",
    createdAt: "2025-08-31T10:36:14.705Z",
    dept: "ME",
    id: 166,
    name_: "Niranjan K Sabu",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Niranjan_K_Sabu_cv_2025.png",
    title: "Linde | ME",
  },
  {
    category: "core",
    company: "Caterpillar",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Spandan_Samanta_cv_2025.png",
    createdAt: "2025-08-31T10:33:28.770Z",
    dept: "AE",
    id: 165,
    name_: "Spandan Samanta",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Spandan_Samanta_cv_2025.png",
    title: "Caterpillar | AE",
  },
  {
    category: "core",
    company: "OLA Electric",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Pratham_Vishwakarma_cv_2025.png",
    createdAt: "2025-08-31T10:31:12.565Z",
    dept: "ME",
    id: 164,
    name_: "Pratham Vishwakarma",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Pratham_Vishwakarma_cv_2025.png",
    title: "OLA Electric | ME",
  },
  {
    category: "software",
    company: "Trimble",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Harshwardhan_Tanwar_cv_2025.png",
    createdAt: "2025-08-31T10:27:42.573Z",
    dept: "AR",
    id: 163,
    name_: "Harshwardhan Tanwar",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Harshwardhan_Tanwar_cv_2025.png",
    title: "Trimble | AR",
  },
  {
    category: "data",
    company: "American Express",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Jayatee_Srivastava_cv_2025.png",
    createdAt: "2025-08-31T10:25:08.043Z",
    dept: "HS",
    id: 162,
    name_: "Jayatee Srivastava",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Jayatee_Srivastava_cv_2025.png",
    title: "American Express | HS",
  },
  {
    category: "software",
    company: "PhonePe",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Ayush_Singh_cv_2025.png",
    createdAt: "2025-08-31T10:21:00.409Z",
    dept: "CH",
    id: 161,
    name_: "Ayush Singh",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Ayush_Singh_cv_2025.png",
    title: "PhonePe | CH",
  },
  {
    category: "core",
    company: "Secpod ",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Soumodipta_Jana_cv_2025.png",
    createdAt: "2025-08-31T10:15:34.675Z",
    dept: "MA",
    id: 160,
    name_: "Soumodipta Jana",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Soumodipta_Jana_cv_2025.png",
    title: "Secpod | MA",
  },
  {
    category: "quant",
    company: "Xion Multiventures",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Sarvesh_Kale_cv_2025.png",
    createdAt: "2025-08-31T10:00:34.720Z",
    dept: "MF",
    id: 159,
    name_: "Sarvesh Kale",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Sarvesh_Kale_cv_2025.png",
    title: "Xion Multiventures | MF",
  },
  {
    category: "software",
    company: "Mathworks",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Ritam_Pradhan_cv_2025.png",
    createdAt: "2025-08-31T09:58:24.634Z",
    dept: "QE",
    id: 158,
    name_: "Ritam Pradhan",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Ritam_Pradhan_cv_2025.png",
    title: "Mathworks | QE",
  },
  {
    category: "software",
    company: "Meesho",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Sanket_Jaipuriar_cv_2025.png",
    createdAt: "2025-08-31T09:56:57.933Z",
    dept: "CE",
    id: 157,
    name_: "Sanket Jaipuriar",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Sanket_Jaipuriar_cv_2025.png",
    title: "Meesho | CE",
  },
  {
    category: "software",
    company: "Mastercard",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Lav_Jharwal_cv_2025.png",
    createdAt: "2025-08-31T09:56:19.742Z",
    dept: "CS",
    id: 156,
    name_: "Lav Jharwal",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Lav_Jharwal_cv_2025.png",
    title: "Mastercard | CS",
  },
  {
    category: "software",
    company: "Samsara",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Daksh_Kochhar_cv_2025.png",
    createdAt: "2025-08-31T09:55:03.827Z",
    dept: "EE",
    id: 155,
    name_: "Daksh Kochhar",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Daksh_Kochhar_cv_2025.png",
    title: "Samsara | EE",
  },
  {
    category: "data",
    company: "InfoEdge",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Adarsh_Tiwari_cv_2025.png",
    createdAt: "2025-08-31T09:54:19.933Z",
    dept: "HS",
    id: 154,
    name_: "Adarsh Tiwari",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Adarsh_Tiwari_cv_2025.png",
    title: "InfoEdge | HS",
  },
  {
    category: "product",
    company: "Micron Technology",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Sudeep_Sudarshan_Rana_cv_2025.png",
    createdAt: "2025-08-31T09:52:51.123Z",
    dept: "EE",
    id: 153,
    name_: "Sudeep Sudarshan Rana",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Sudeep_Sudarshan_Rana_cv_2025.png",
    title: "Micron Technology | EE",
  },
  {
    category: "data",
    company: "Mercari",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Alankrita_Roy_cv_2025.png",
    createdAt: "2025-08-31T09:52:22.315Z",
    dept: "AG",
    id: 152,
    name_: "Alankrita Roy",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Alankrita_Roy_cv_2025.png",
    title: "Mercari | AG",
  },
  {
    category: "data",
    company: "American Express",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Kaushal_Jadhav_cv_2025.png",
    createdAt: "2025-08-31T09:50:00.878Z",
    dept: "EC",
    id: 151,
    name_: "Kaushal Jadhav",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Kaushal_Jadhav_cv_2025.png",
    title: "American Express | EC",
  },
  {
    category: "finance",
    company: "ICICI Bank",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Challa_Naga_Sujan_cv_2025.png",
    createdAt: "2025-08-31T09:47:18.438Z",
    dept: "CE",
    id: 150,
    name_: "Challa Naga Sujan",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Challa_Naga_Sujan_cv_2025.png",
    title: "ICICI Bank | CE",
  },
  {
    category: "software",
    company: "Microsoft",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Indra_Kumar_Gupta_cv_2025.png",
    createdAt: "2025-08-31T09:47:00.345Z",
    dept: "AE",
    id: 149,
    name_: "Indra Kumar Gupta",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Indra_Kumar_Gupta_cv_2025.png",
    title: "Microsoft | AE",
  },
  {
    category: "finance",
    company: "Axxela ",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Aditya_Ravte_cv_2025.png",
    createdAt: "2025-08-31T09:44:17.855Z",
    dept: "HS",
    id: 148,
    name_: "Aditya Ravte",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Aditya_Ravte_cv_2025.png",
    title: "Axxela | HS",
  },
  {
    category: "data",
    company: "Capital One",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Rishabh_Jain_cv_2025.png",
    createdAt: "2025-08-31T09:42:56.831Z",
    dept: "HS",
    id: 147,
    name_: "Rishabh Jain",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Rishabh_Jain_cv_2025.png",
    title: "Capital One | HS",
  },
  {
    category: "software",
    company: "Google",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Vyshnavi_Lagudu_cv_2025.png",
    createdAt: "2025-08-31T09:41:54.163Z",
    dept: "EE",
    id: 146,
    name_: "Vyshnavi Lagudu",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Vyshnavi_Lagudu_cv_2025.png",
    title: "Google | EE",
  },
  {
    category: "data",
    company: "Tiger Analytics",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Anamika_Kumari_cv_2025.png",
    createdAt: "2025-08-31T09:39:15.946Z",
    dept: "AE",
    id: 145,
    name_: "Anamika Kumari",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Anamika_Kumari_cv_2025.png",
    title: "Tiger Analytics | AE",
  },
  {
    category: "consultancy",
    company: "Auctus Advisors",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Riddhima_Biyani_cv_2025.png",
    createdAt: "2025-08-31T09:36:33.140Z",
    dept: "HS",
    id: 144,
    name_: "Riddhima Biyani",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Riddhima_Biyani_cv_2025.png",
    title: "Auctus Advisors | HS",
  },
  {
    category: "software",
    company: "Bank of America ",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Dipan_Mandal_cv_2025.png",
    createdAt: "2025-08-31T09:34:27.661Z",
    dept: "CS",
    id: 143,
    name_: "Dipan Mandal",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Dipan_Mandal_cv_2025.png",
    title: "Bank of America | CS",
  },
  {
    category: "core",
    company: "DTDC Express Limited",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Arup_Mahatha_cv_2025.png",
    createdAt: "2025-08-31T09:32:52.488Z",
    dept: "NA",
    id: 142,
    name_: "Arup Mahatha",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Arup_Mahatha_cv_2025.png",
    title: "DTDC Express Limited | NA",
  },
  {
    category: "data",
    company: "Axtria - Ingenious Insights ",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Tejas_Khandare_cv_2025.png",
    createdAt: "2025-08-31T09:31:24.315Z",
    dept: "MF",
    id: 141,
    name_: "Tejas Khandare",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Tejas_Khandare_cv_2025.png",
    title: "Axtria - Ingenious Insights | MF",
  },
  {
    category: "finance",
    company: "WhiteOak Capital",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Tejas_Manish_Saxena_cv_2025.png",
    createdAt: "2025-08-31T09:19:23.061Z",
    dept: "CH",
    id: 140,
    name_: "Tejas Manish Saxena",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Tejas_Manish_Saxena_cv_2025.png",
    title: "WhiteOak Capital | CH",
  },
  {
    category: "quant",
    company: "Sqarepoint Capital",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Karan_Ralhan_cv_2025.png",
    createdAt: "2025-08-31T09:12:44.481Z",
    dept: "MA ",
    id: 139,
    name_: "Karan Ralhan",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Karan_Ralhan_cv_2025.png",
    title: "Sqarepoint Capital | MA",
  },
  {
    category: "core",
    company: "Bluestone",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Rishabh_Raj_cv_2025.png",
    createdAt: "2025-08-31T07:28:42.651Z",
    dept: "IM",
    id: 138,
    name_: "Rishabh Raj",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Rishabh_Raj_cv_2025.png",
    title: "Bluestone | IM",
  },
  {
    category: "data",
    company: "ICICI Bank",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Sanket_Jagtap_cv_2025.png",
    createdAt: "2025-08-31T07:11:26.542Z",
    dept: "AG",
    id: 137,
    name_: "Sanket Jagtap",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Sanket_Jagtap_cv_2025.png",
    title: "ICICI Bank | AG",
  },
  {
    category: "core",
    company: "Texas Instruments",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Kommana_Satya_Sai_cv_2025.png",
    createdAt: "2025-08-31T07:07:42.827Z",
    dept: "EE",
    id: 136,
    name_: "Kommana Satya Sai",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Kommana_Satya_Sai_cv_2025.png",
    title: "Texas Instruments | EE",
  },
  {
    category: "consultancy",
    company: "Nation With Namo (NwN)",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Kunal_Kumar_cv_2025.png",
    createdAt: "2025-08-31T07:03:03.556Z",
    dept: "CE",
    id: 135,
    name_: "Kunal Kumar",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Kunal_Kumar_cv_2025.png",
    title: "Nation With Namo (NwN) | CE",
  },
  {
    category: "software",
    company: "Capital One",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Samarth_Somani__cv_2025.png",
    createdAt: "2025-08-30T14:08:01.297Z",
    dept: "MA",
    id: 134,
    name_: "Samarth Somani ",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Samarth_Somani__cv_2025.png",
    title: "Capital One | MA",
  },
  {
    category: "consultancy",
    company: "ZS",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Bishu_cv_2025.png",
    createdAt: "2025-08-30T13:59:02.436Z",
    dept: "CH",
    id: 133,
    name_: "Bishu",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Bishu_cv_2025.png",
    title: "ZS | CH",
  },
  {
    category: "core",
    company: "Quasistatics",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Saluru_Dheerajeswar_cv_2025.png",
    createdAt: "2025-08-30T13:46:42.277Z",
    dept: "EC",
    id: 132,
    name_: "Saluru Dheerajeswar",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Saluru_Dheerajeswar_cv_2025.png",
    title: "Quasistatics | EC",
  },
  {
    category: "core",
    company: "MICRON TECHNOLOGY",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Shailesh_Pathak_cv_2025.png",
    createdAt: "2025-08-30T13:42:01.328Z",
    dept: "EC",
    id: 131,
    name_: "Shailesh Pathak",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Shailesh_Pathak_cv_2025.png",
    title: "MICRON TECHNOLOGY | EC",
  },
  {
    category: "data",
    company: "ThoughtSpot",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Juzar_Ali_Batterywala_cv_2025.png",
    createdAt: "2025-08-30T13:35:14.735Z",
    dept: "GG",
    id: 130,
    name_: "Juzar Ali Batterywala",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Juzar_Ali_Batterywala_cv_2025.png",
    title: "ThoughtSpot | GG",
  },
  {
    category: "core",
    company: "Intel",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Chirantan_Ganguly_cv_2025.png",
    createdAt: "2025-08-30T09:07:17.158Z",
    dept: "PH",
    id: 129,
    name_: "Chirantan Ganguly",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Chirantan_Ganguly_cv_2025.png",
    title: "Intel | PH",
  },
  {
    category: "finance",
    company: "ICICI Bank",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Sarnab_Banerjee_cv_2025.png",
    createdAt: "2025-08-30T09:07:12.002Z",
    dept: "MF",
    id: 128,
    name_: "Sarnab Banerjee",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Sarnab_Banerjee_cv_2025.png",
    title: "ICICI Bank | MF",
  },
  {
    category: "core",
    company: "Saint - Gobain Research",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/KHANSA_SHAHNAWAZ_cv_2025.png",
    createdAt: "2025-08-28T14:48:10.017Z",
    dept: "MT",
    id: 127,
    name_: "Khansa Shahnawaz",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/KHANSA_SHAHNAWAZ_cv_2025.png",
    title: "Saint - Gobain Research | MT",
  },
  {
    category: "consultancy",
    company: "EXL ",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/loyavivek_cv.png",
    createdAt: "2025-07-01T22:24:12.055Z",
    dept: "MF",
    id: 116,
    name_: "Loya Vivek",
    profilecolor: "green",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/loyavivek_cv.png",
    title: "EXL | MF",
  },
  {
    category: "finance",
    company: "Capital One",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Aman_Kedia_cv_2026.png",
    createdAt: "2025-07-01T22:24:11.921Z",
    dept: "CH",
    id: 115,
    name_: "Aman Kedia",
    profilecolor: "green",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Aman_Kedia_cv_2026.png",
    title: "Capital One | CH",
  },
  {
    category: "core",
    company: "Tata Steel",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/himanshukamalvanshi.png",
    createdAt: "2025-07-01T22:24:11.790Z",
    dept: "CH",
    id: 114,
    name_: "Himanshu Kamalvanshi",
    profilecolor: "green",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/himanshukamalvanshi.png",
    title: "Tata Steel | CH",
  },
  {
    category: "software",
    company: "Siemens EDA",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/tanmoydutta.png",
    createdAt: "2025-07-01T22:24:11.660Z",
    dept: "EE",
    id: 113,
    name_: "Tanmoy Dutta",
    profilecolor: "green",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/tanmoydutta.png",
    title: "Siemens EDA | EE",
  },
  {
    category: "finance",
    company: "Flipkart",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/shubhamjaiswal_cv.png",
    createdAt: "2025-07-01T22:24:11.529Z",
    dept: "ME",
    id: 112,
    name_: "Shubham Jaiswal",
    profilecolor: "green",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/shubhamjaiswal_cv.png",
    title: "Flipkart | ME",
  },
  {
    category: "core",
    company: "Qualcomm",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/ankitadas_cv.png",
    createdAt: "2025-07-01T22:24:11.388Z",
    dept: "EC",
    id: 111,
    name_: "Ankita Das",
    profilecolor: "green",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/ankitadas_cv.png",
    title: "Qualcomm | EC",
  },
  {
    category: "product",
    company: "Navi Technologies",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/divyanshugupta_cv.png",
    createdAt: "2025-07-01T22:24:11.259Z",
    dept: "BT",
    id: 110,
    name_: "Divyanshu Gupta",
    profilecolor: "green",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/divyanshugupta_cv.png",
    title: "Navi Technologies | BT",
  },
  {
    category: "finance",
    company: "Flipkart",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/omeekatrodia_cv.png",
    createdAt: "2025-07-01T22:24:11.127Z",
    dept: "AE",
    id: 109,
    name_: "Omee Katrodia",
    profilecolor: "green",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/omeekatrodia_cv.png",
    title: "Flipkart | AE",
  },
  {
    category: "data",
    company: "Navi Technologies",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/anubhavprasad_cv.png",
    createdAt: "2025-07-01T22:24:10.994Z",
    dept: "EC",
    id: 108,
    name_: "Anubhav Prasad",
    profilecolor: "green",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/anubhavprasad_cv.png",
    title: "Navi Technologies | EC",
  },
  {
    category: "data",
    company: "Mercedes Benz",
    cover: "https://miro.medium.com/v2/resize:fit:1400/0*XBPsFlQU5yfFXgXk",
    createdAt: "2025-07-01T22:24:10.865Z",
    dept: "CE",
    id: 107,
    name_: "Renu T. Rathod",
    profilecolor: "green",
    thumbnail: "https://miro.medium.com/v2/resize:fit:500/0*XBPsFlQU5yfFXgXk",
    title: "Mercedes Benz | CE",
  },
  {
    category: "software",
    company: "Microsoft",
    cover: "https://miro.medium.com/v2/resize:fit:1100/format:webp/1*EKVnM-BMtb-ey5eoHiVOGw.png",
    createdAt: "2025-07-01T22:24:10.734Z",
    dept: "CE",
    id: 106,
    name_: "Abhay P S Bhadoriya",
    profilecolor: "green",
    thumbnail: "https://miro.medium.com/v2/resize:fit:500/format:webp/1*EKVnM-BMtb-ey5eoHiVOGw.png",
    title: "Microsoft | CE",
  },
  {
    category: "software",
    company: "Google",
    cover: "https://miro.medium.com/v2/resize:fit:1100/format:webp/1*AIuux4W2zN--iyxbNMa_uA.jpeg",
    createdAt: "2025-07-01T22:24:10.601Z",
    dept: "ECE",
    id: 105,
    name_: "Tias Mondal",
    profilecolor: "green",
    thumbnail: "https://miro.medium.com/v2/resize:fit:500/format:webp/1*AIuux4W2zN--iyxbNMa_uA.jpeg",
    title: "Google | ECE",
  },
  {
    category: "software",
    company: "BNY Melon",
    cover: "https://miro.medium.com/v2/resize:fit:1100/format:webp/1*bYzejXxQsBhTMsYZF2a5fA.jpeg",
    createdAt: "2025-07-01T22:24:10.471Z",
    dept: "IM",
    id: 104,
    name_: "Visesh Kaushik K.",
    profilecolor: "green",
    thumbnail: "https://miro.medium.com/v2/resize:fit:500/format:webp/1*bYzejXxQsBhTMsYZF2a5fA.jpeg",
    title: "BNY Melon | IM",
  },
  {
    category: "core",
    company: "Qualcomm",
    cover: "https://miro.medium.com/v2/resize:fit:1100/format:webp/1*bRE3mOY1XWMpAvyQ2pmEsg.png",
    createdAt: "2025-07-01T22:24:10.341Z",
    dept: "EE",
    id: 103,
    name_: "Jogadenu Kalyanraman",
    profilecolor: "green",
    thumbnail: "https://miro.medium.com/v2/resize:fit:500/format:webp/1*bRE3mOY1XWMpAvyQ2pmEsg.png",
    title: "Qualcomm| EE",
  },
  {
    category: "core",
    company: "Western digitals",
    cover: "https://miro.medium.com/v2/resize:fit:1100/format:webp/1*J6O8rB6PVLg7EMBnr-El4A.jpeg",
    createdAt: "2025-07-01T22:24:10.213Z",
    dept: "EE",
    id: 102,
    name_: "Seelam Shiva Surya",
    profilecolor: "green",
    thumbnail: "https://miro.medium.com/v2/resize:fit:500/format:webp/1*J6O8rB6PVLg7EMBnr-El4A.jpeg",
    title: "Western digitals| EE",
  },
  {
    category: "quant",
    company: "JPMC",
    cover: "https://miro.medium.com/v2/resize:fit:1100/format:webp/1*3csde1hEKZYzwk7cNcc1jQ.jpeg",
    createdAt: "2025-07-01T22:24:10.081Z",
    dept: "ME",
    id: 101,
    name_: "Raj Kumar Singh",
    profilecolor: "green",
    thumbnail: "https://miro.medium.com/v2/resize:fit:500/format:webp/1*3csde1hEKZYzwk7cNcc1jQ.jpeg",
    title: "JPMC | ME",
  },
  {
    category: "software",
    company: "Cisco",
    cover: "https://miro.medium.com/v2/resize:fit:1100/format:webp/1*E-yKZVsREMpO9T1nv1_DFw.jpeg",
    createdAt: "2025-07-01T22:24:09.951Z",
    dept: "CSE",
    id: 100,
    name_: "Veligeti Vineeth",
    profilecolor: "green",
    thumbnail: "https://miro.medium.com/v2/resize:fit:500/format:webp/1*E-yKZVsREMpO9T1nv1_DFw.jpeg",
    title: "Cisco|CSE",
  },
  {
    category: "core",
    company: "Dr Reddys",
    cover: "https://miro.medium.com/v2/resize:fit:1100/format:webp/1*bdb_yVQPZfxuSCSIUJ11Kg.jpeg",
    createdAt: "2025-07-01T22:24:09.820Z",
    dept: "CH",
    id: 99,
    name_: "Shakul Pathak",
    profilecolor: "green",
    thumbnail: "https://miro.medium.com/v2/resize:fit:500/format:webp/1*bdb_yVQPZfxuSCSIUJ11Kg.jpeg",
    title: "Dr Reddys | CH",
  },
  {
    category: "data",
    company: "Mercedes Benz",
    cover: "https://miro.medium.com/v2/resize:fit:1100/format:webp/1*Ftjk8HOYu-MXfk62CtqUPA.jpeg",
    createdAt: "2025-07-01T22:24:09.691Z",
    dept: "EE",
    id: 98,
    name_: "Anuraag Bhattacharya",
    profilecolor: "green",
    thumbnail: "https://miro.medium.com/v2/resize:fit:500/format:webp/1*Ftjk8HOYu-MXfk62CtqUPA.jpeg",
    title: "Mercedes Benz | EE",
  },
  {
    category: "software",
    company: "Google",
    cover: "https://miro.medium.com/v2/resize:fit:1100/format:webp/1*MF6ghtK6GwkLhMefdRku-Q.jpeg",
    createdAt: "2025-07-01T22:24:09.557Z",
    dept: "MA",
    id: 97,
    name_: "Sohan Rudra",
    profilecolor: "green",
    thumbnail: "https://miro.medium.com/v2/resize:fit:500/format:webp/1*MF6ghtK6GwkLhMefdRku-Q.jpeg",
    title: "Google | MA",
  },
  {
    category: "consultancy",
    company: "Accenture",
    cover: "https://miro.medium.com/v2/resize:fit:1100/format:webp/1*X2YT7OE1EFvE1TjafO60vg.jpeg",
    createdAt: "2025-07-01T22:24:09.424Z",
    dept: "MF",
    id: 96,
    name_: "Pratyusha Mondal",
    profilecolor: "green",
    thumbnail: "https://miro.medium.com/v2/resize:fit:500/format:webp/1*X2YT7OE1EFvE1TjafO60vg.jpeg",
    title: "Accenture | MF",
  },
  {
    category: "software",
    company: "Wells Fargo",
    cover: "https://miro.medium.com/v2/resize:fit:1100/format:webp/1*Gab6XFgDXT5pDwV4-t1oow.jpeg",
    createdAt: "2025-07-01T22:24:09.289Z",
    dept: "MA",
    id: 95,
    name_: "Bharat Chaudhary",
    profilecolor: "green",
    thumbnail: "https://miro.medium.com/v2/resize:fit:500/format:webp/1*Gab6XFgDXT5pDwV4-t1oow.jpeg",
    title: "Wells Fargo | MA",
  },
  {
    category: "quant",
    company: "Graviton",
    cover: "https://miro.medium.com/v2/resize:fit:1100/format:webp/1*J5ZRb_Z-7EYGGUJh1GsQiQ.jpeg",
    createdAt: "2025-07-01T22:24:09.160Z",
    dept: "CSE",
    id: 94,
    name_: "Yash P. Butala",
    profilecolor: "green",
    thumbnail: "https://miro.medium.com/v2/resize:fit:500/format:webp/1*J5ZRb_Z-7EYGGUJh1GsQiQ.jpeg",
    title: "Graviton | CSE",
  },
  {
    category: "data",
    company: "Rakuten",
    cover: "https://miro.medium.com/v2/resize:fit:1100/format:webp/1*qKSog_JRLvdhxzoeyzikXg.png",
    createdAt: "2025-07-01T22:24:09.025Z",
    dept: "ECE",
    id: 93,
    name_: "Saikat Mondal",
    profilecolor: "green",
    thumbnail: "https://miro.medium.com/v2/resize:fit:500/format:webp/1*qKSog_JRLvdhxzoeyzikXg.png",
    title: "Rakuten | ECE",
  },
  {
    category: "product",
    company: "Groww",
    cover: "https://miro.medium.com/v2/resize:fit:1100/format:webp/1*z1Mcz3TwMxdq8y7nI17w1g.png",
    createdAt: "2025-07-01T22:24:08.894Z",
    dept: "AG",
    id: 92,
    name_: "Abhijeet Mahato",
    profilecolor: "green",
    thumbnail: "https://miro.medium.com/v2/resize:fit:500/format:webp/1*z1Mcz3TwMxdq8y7nI17w1g.png",
    title: "Groww | AG",
  },
  {
    category: "core",
    company: "JLR",
    cover: "https://miro.medium.com/v2/resize:fit:1100/format:webp/1*qjGu_mOVPnjKSApkSCScXA.png",
    createdAt: "2025-07-01T22:24:08.764Z",
    dept: "ECE",
    id: 91,
    name_: "N Abhilaash Reddy",
    profilecolor: "green",
    thumbnail: "https://miro.medium.com/v2/resize:fit:500/format:webp/1*qjGu_mOVPnjKSApkSCScXA.png",
    title: "JLR | ECE",
  },
  {
    category: "data",
    company: "Tiger Analytics",
    cover: "https://miro.medium.com/v2/resize:fit:1100/format:webp/1*4kGW5YLLRqu6tqL7-Ky_5w.png",
    createdAt: "2025-07-01T22:24:08.634Z",
    dept: "ME",
    id: 90,
    name_: "Arka Mandal",
    profilecolor: "Red",
    thumbnail: "https://miro.medium.com/v2/resize:fit:500/format:webp/1*4kGW5YLLRqu6tqL7-Ky_5w.png",
    title: "Tiger analytics | ME",
  },
  {
    category: "finance",
    company: "ICICI",
    cover: "https://miro.medium.com/v2/resize:fit:1100/0*Q2hZoPN4LQ1mPGL4",
    createdAt: "2025-07-01T22:24:08.503Z",
    dept: "MF",
    id: 89,
    name_: "Chitranshu Ranjan",
    profilecolor: "orange",
    thumbnail: "https://miro.medium.com/v2/resize:fit:500/0*Q2hZoPN4LQ1mPGL4",
    title: "ICICI | MF",
  },
  {
    category: "core",
    company: "Bajaj",
    cover: "https://miro.medium.com/v2/resize:fit:1100/format:webp/1*dlR4BoasGVz45DrBSacdwA.png",
    createdAt: "2025-07-01T22:24:08.373Z",
    dept: "AE",
    id: 88,
    name_: "GV Sai Harshit",
    profilecolor: "#FFC0CB",
    thumbnail: "https://miro.medium.com/v2/resize:fit:500/format:webp/1*dlR4BoasGVz45DrBSacdwA.png",
    title: " Bajaj|AE ",
  },
  {
    category: "core",
    company: "Texas Instruments",
    cover: "https://miro.medium.com/v2/resize:fit:1100/format:webp/1*EIk09v-jQbxFi1S_V27cHw.png",
    createdAt: "2025-07-01T22:24:08.241Z",
    dept: "ECE",
    id: 87,
    name_: "Yashwanth Pavilla",
    profilecolor: "#FFC0CB",
    thumbnail: "https://miro.medium.com/v2/resize:fit:500/format:webp/1*EIk09v-jQbxFi1S_V27cHw.png",
    title: "Texas | ECE",
  },
  {
    category: "core",
    company: "Ola",
    cover: "https://miro.medium.com/v2/resize:fit:1400/format:webp/1*NOE7JVyRUxzmGk4e5n9yZA.png",
    createdAt: "2025-07-01T22:24:08.106Z",
    dept: "ME",
    id: 86,
    name_: "Shikhar Goel",
    profilecolor: "#FFC0CB",
    thumbnail: "https://miro.medium.com/v2/resize:fit:1400/format:webp/1*NOE7JVyRUxzmGk4e5n9yZA.png",
    title: "OLA | ME",
  },
  {
    category: "quant",
    company: "Morgan Stanley",
    cover: "https://miro.medium.com/v2/resize:fit:1400/format:webp/1*tx9LZVfovurikcwk7-1YQg.png",
    createdAt: "2025-07-01T22:24:07.976Z",
    dept: "MA",
    id: 85,
    name_: "Suranjan Mondal",
    profilecolor: "#FFC0CB",
    thumbnail: "https://miro.medium.com/v2/resize:fit:500/format:webp/1*tx9LZVfovurikcwk7-1YQg.png",
    title: "Morgan stanley | MA",
  },
  {
    category: "software",
    company: "BNY Mellon",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/abhilash_cv.jpg",
    createdAt: "2025-07-01T22:24:07.841Z",
    dept: "CH",
    id: 84,
    name_: "Abhilash Sinha",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/abhilash_cv.jpg",
    title: "BNY Mellon | CH",
  },
  {
    category: "software",
    company: "Rakuten",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/abhishant_cv.jpg",
    createdAt: "2025-07-01T22:24:07.711Z",
    dept: "IM",
    id: 83,
    name_: "Abhishant Kumar",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/abhishant_cv.jpg",
    title: "Rakuten | IM",
  },
  {
    category: "core",
    company: "Airbus",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/abhishek_cv.jpg",
    createdAt: "2025-07-01T22:24:07.580Z",
    dept: "MT",
    id: 82,
    name_: "Abhishek Kumar Roy",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/abhishek_cv.jpg",
    title: "Airbus | MT",
  },
  {
    category: "software",
    company: "Apollo",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/ashwin_cv.jpg",
    createdAt: "2025-07-01T22:24:07.450Z",
    dept: "CSE",
    id: 81,
    name_: "A Ashwin Sai",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/ashwin_cv.jpg",
    title: "Apollo | CS",
  },
  {
    category: "core",
    company: "Cairn Oil & Gas Vedanta Ltd",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/avilipsa_cv.jpg",
    createdAt: "2025-07-01T22:24:07.315Z",
    dept: "GG",
    id: 80,
    name_: "Avilipsa Tripathy",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/avilipsa_cv.jpg",
    title: "Cairn Oil & Gas Vedanta Ltd | GG",
  },
  {
    category: "core",
    company: "TSMC",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/ayush_cv.jpg",
    createdAt: "2025-07-01T22:24:07.183Z",
    dept: "EC",
    id: 79,
    name_: "Ayush Kumar Rai",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/ayush_cv.jpg",
    title: "TSMC | EC",
  },
  {
    category: "consultancy",
    company: "Bain & Co.",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/debraj_cv.jpg",
    createdAt: "2025-07-01T22:24:07.054Z",
    dept: "IM",
    id: 78,
    name_: "Debraj Chatterjee",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/debraj_cv.jpg",
    title: "Bain & Co. | IM",
  },
  {
    category: "data",
    company: "American Express",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/gauri_cv.jpg",
    createdAt: "2025-07-01T22:24:06.923Z",
    dept: "AR",
    id: 77,
    name_: "Gauri Sanjay Karkhanis",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/gauri_cv.jpg",
    title: "American Express | AR",
  },
  {
    category: "software",
    company: "Apple",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/mohit_cv.jpg",
    createdAt: "2025-07-01T22:24:06.795Z",
    dept: "EC",
    id: 75,
    name_: "Mohit Gupta",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/mohit_cv.jpg",
    title: "Apple | EC",
  },
  {
    category: "software",
    company: "American Express",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/shrey_cv.jpg",
    createdAt: "2025-07-01T22:24:06.660Z",
    dept: "AE",
    id: 73,
    name_: "Shrey Sharma",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/shrey_cv.jpg",
    title: "American Express | AE",
  },
  {
    category: "software",
    company: "TSMC",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/soumyajit_cv.jpg",
    createdAt: "2025-07-01T22:24:06.529Z",
    dept: "MA",
    id: 72,
    name_: "Soumyajit Chakraborty",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/soumyajit_cv.jpg",
    title: "TSMC | MA",
  },
  {
    category: "core",
    company: "Collins Aerospace",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/sumeet_cv.jpg",
    createdAt: "2025-07-01T22:24:06.397Z",
    dept: "ME",
    id: 71,
    name_: "Singh Sumeet Subodh",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/sumeet_cv.jpg",
    title: "Collins Aerospace | ME",
  },
  {
    category: "data",
    company: "American Express",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/swagat_cv.jpg",
    createdAt: "2025-07-01T22:24:06.264Z",
    dept: "ME",
    id: 70,
    name_: "Swagat Susmoy Sahoo",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/swagat_cv.jpg",
    title: "American Express | ME",
  },
  {
    category: "core",
    company: "Texas Instruments",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Arpan_Deb_cv_2026.png",
    createdAt: "2025-07-01T22:24:06.133Z",
    dept: "EE",
    id: 126,
    name_: "Arpan Deb",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Arpan_Deb_cv_2026.png",
    title: "Texas Instruments | EE",
  },
  {
    category: "core",
    company: "TVS",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/ankitanuragi_cv.png",
    createdAt: "2025-07-01T22:24:05.997Z",
    dept: "MT",
    id: 125,
    name_: "Ankit Anuragi",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/ankitanuragi_cv.png",
    title: "TVS | MT",
  },
  {
    category: "core",
    company: "Nvidia",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/kartikpontula_cv.png",
    createdAt: "2025-07-01T22:24:05.867Z",
    dept: "CS",
    id: 124,
    name_: "Kartik Pontula",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/kartikpontula_cv.png",
    title: "Nvidia | CS",
  },
  {
    category: "core",
    company: "Squarepoint Captial",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/vishalravipati_cv.png",
    createdAt: "2025-07-01T22:24:05.738Z",
    dept: "CS",
    id: 123,
    name_: "Vishal Ravipati",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/vishalravipati_cv.png",
    title: "Squarepoint Captial | CS",
  },
  {
    category: "core",
    company: "Nvidia",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/muskankapoor_cv.png",
    createdAt: "2025-07-01T22:24:05.606Z",
    dept: "EC",
    id: 122,
    name_: "Muskan Kapoor",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/muskankapoor_cv.png",
    title: "Nvidia | EC",
  },
  {
    category: "core",
    company: "Jaguar Land Rover",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/preetinilanjana_cv.png",
    createdAt: "2025-07-01T22:24:05.475Z",
    dept: "EE",
    id: 121,
    name_: "Preeti Nilanjana",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/preetinilanjana_cv.png",
    title: "Jaguar Land Rover | EE",
  },
  {
    category: "core",
    company: "Intel",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/crvivroshan_cv.png",
    createdAt: "2025-07-01T22:24:05.344Z",
    dept: "PH",
    id: 120,
    name_: "C R Vivroshan",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/crvivroshan_cv.png",
    title: "Intel | PH",
  },
  {
    category: "data",
    company: "Navi Technologies",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/saurabhmishra_cv.png",
    createdAt: "2025-07-01T22:24:05.211Z",
    dept: "EE",
    id: 119,
    name_: "Saurabh Mishra",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/saurabhmishra_cv.png",
    title: "Navi Technologies | EE",
  },
  {
    category: "software",
    company: "Nvidia",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/dhruvrathi_cv.png",
    createdAt: "2025-07-01T22:24:05.081Z",
    dept: "EC",
    id: 118,
    name_: "Dhruv Rathi",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/dhruvrathi_cv.png",
    title: "Nvidia | EC",
  },
  {
    category: "data",
    company: "Flipkart",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/aditiujjain_cv.png",
    createdAt: "2025-07-01T22:24:04.946Z",
    dept: "MI",
    id: 117,
    name_: "Aditi Ujjain",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/aditiujjain_cv.png",
    title: "Flipkart | MI",
  },
];
